export default __webpack_public_path__ + "static/media/april.bb157082.jpg";